import axiosInstance from "../../../services/config/axiosinstance";
import { urlBaseAccreditation } from './../../config/index';

export default async function getActionsErrorsApi(
  eventId = ''
) {
  try {
    const _ret = await axiosInstance({
      url: `${urlBaseAccreditation}/action/getErrorsList`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
      params: {
        eventId: parseInt(eventId),
        apiType: 'inteegra',
      }
    });

    if (!_ret.data.success) {
      throw new Error(_ret.data.message);
    }

    return _ret.data.data;

  } catch (error) {
    console.log('Error getActionsErrorsApi', error);
    throw error;
  }
}
